import { Application } from '@siposdani87/sui-js';
import { config } from './config';
import { resources } from './resources';

export const app = new Application(config, resources);
